export default {
    state: {
        id: null,
        name: null,
        portrait: null,
        affiliate_posts: []
    },
    mutations: {
        setAffiliateId (state, payload) {
            state.id = payload
        },
        setAffiliateName (state, payload) {
            state.name = payload
        },
        setAffiliatePortrait (state, payload) {
            state.portrait = payload
        },
        setAffiliatePosts (state, payload) {
            state.affiliate_posts = payload
        }
    },
    getters: {},
    actions: {
        getAffiliatePosts (context, state) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get("dashboard/affiliate/posts")
                .then(response => {
                    let posts = []

                    if (response.data) {
                        posts = response.data
                    }

                    context.commit('setAffiliatePosts', posts)

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        }
    }
}
